var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"omapi-subscribers-page omapi-subscribers-contacts"},[_c('div',{staticClass:"omapi-monsterleads"},[(_vm.showNoSubscribers)?_c('monsterleads-contacts-no-subscribers'):_c('monsterleads-contacts-table')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }